import type { IMatrixColumn, IColumnDepRef } from './progressMatrix';

function depsEqual(a: IColumnDepRef[] | undefined, b: IColumnDepRef[] | undefined): boolean {
  if (a === b) return true;
  if (!a || !b || a.length !== b.length) return false;
  return a.every((d, i) => {
    const e = b[i]!;
    return d.id === e.id && d.name === e.name && d.progressPercent === e.progressPercent && d.committed === e.committed;
  });
}

/** Value equality over a rebuilt column. `profession` stays reference-compared:
 *  the query-cache patch preserves untouched task objects, so an unchanged
 *  column carries the same profession reference. */
export function columnEquals(a: IMatrixColumn, b: IMatrixColumn): boolean {
  return (
    a.taskId === b.taskId &&
    a.name === b.name &&
    a.profession === b.profession &&
    a.progressPercent === b.progressPercent &&
    a.isGroup === b.isGroup &&
    a.isMilestone === b.isMilestone &&
    a.isCritical === b.isCritical &&
    a.onTimeRisk === b.onTimeRisk &&
    depsEqual(a.predecessors, b.predecessors) &&
    depsEqual(a.successors, b.successors)
  );
}
